import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from '../services/data.service';
import { API_ENDPOINT$ } from '../shared/index';
@Injectable({
  providedIn: 'root'
})
export class LoadService {
  private getMetersOfLoadsUrl = `${API_ENDPOINT$}/common/getMetersOfLoads`;
  private getMetersFromLoadIdsUrl = `${API_ENDPOINT$}/common/getMetersFromLoadIds`;
  private getMetersStatusUrl = `${API_ENDPOINT$}/common/getMetersStatus`;
  private getMetersSolarPowerUrl = `${API_ENDPOINT$}/solar/getMetersSolarPower`;
  private getSolarMetersDCPowerUrl = `${API_ENDPOINT$}/solar/getSolarMetersDCPower`;
  private getParamValueForMetersUrl = `${API_ENDPOINT$}/solar/getParamValueForMeters`;
  private sensorHealthBasedOnLevelUrl = `${API_ENDPOINT$}/site/getSensorHealthBasedOnLevel`;

  private getPeerGroupsBySiteIdUrl = `${API_ENDPOINT$}/site/getPeerGroupsBySiteId`;
  private getLoadVerticesOfSiteUrl = `${API_ENDPOINT$}/common/getLoadVerticesOfSite`;
  private getLoadVerticesOfSiteBasedOnUtilityUrl = `${API_ENDPOINT$}/common/getLoadVerticesOfSiteBasedOnUtility`;
  private addNodeForLoadUrl = `${API_ENDPOINT$}/manageproject/addNodeForload`;
  private getLoadsBasedOnTypeAndSubTypeUrl = `${API_ENDPOINT$}/common/getLoadsBasedOnTypeAndSubType`;
  private getSensorDetailsBasedOnLoadIdUrl = `${API_ENDPOINT$}/common/getSensorDetailsBasedOnLoadId`;
  // Add Node
  private addNodesForLoadsUrl = `${API_ENDPOINT$}/load/addNodesForLoads`;
  private getEnergySumForMetersUrl = `${API_ENDPOINT$}/load/getEnergySumForMeters`;
  private saveNodeDetailsForLoadUrl = `${API_ENDPOINT$}/manageproject/saveNodeDetailsForLoad`;
  private saveNodeDetailsUrl = `${API_ENDPOINT$}/manageproject/saveNodeDetails`;
  private getLastRealtimeDataForLoadUrl = `${API_ENDPOINT$}/common/getLastRealtimeDataForLoad`;
  //FAULT STATUS
  private getInvertersFaultStatusUrl = `${API_ENDPOINT$}/solar/getInvertersFaultStatus`;
  constructor(private dataService: DataService) {}

  // {"loadRIds":["#71:288","#482:282"]}
  public getMetersOfLoads(model: any): Observable<any> {
    return this.dataService.postData(this.getMetersOfLoadsUrl, model);
  }
  public getMetersFromLoadIds(model: any): Observable<any> {
    return this.dataService.postData(this.getMetersFromLoadIdsUrl, model);
  }
  public getMetersStatus(model: any, hideLoading: boolean): Observable<any> {
    return this.dataService.postData(
      this.getMetersStatusUrl,
      model,
      hideLoading
    );
  }
  public getMetersSolarPower(model: any): Observable<any> {
    return this.dataService.postData(this.getMetersSolarPowerUrl, model);
  }
  public getSolarMetersDCPower(model: any): Observable<any> {
    return this.dataService.postData(this.getSolarMetersDCPowerUrl, model);
  }
  public getParamValueForMeters(model: any): Observable<any> {
    return this.dataService.postData(this.getParamValueForMetersUrl, model);
  }
  public getSensorHealthBasedOnLevel(model: any): Observable<any> {
    return this.dataService.postData(this.sensorHealthBasedOnLevelUrl, model);
  }
  public getPeerGroupsBySiteId(siteId: string): Observable<any> {
    return this.dataService.getData(
      this.getPeerGroupsBySiteIdUrl + '/' + siteId
    );
  }
  public getAllLoadsOfSite(siteId: string): Observable<any> {
    return this.dataService.getData(
      this.getLoadVerticesOfSiteUrl + '/' + siteId
    );
  }

  /**
   * API call to get all loads for site based on utility
   *
   * @param {string} siteId
   * @param {string} kpiName
   * @return {*}  {Observable<any>}
   * @memberof LoadService
   */
  public getLoadVerticesOfSiteBasedOnUtility(
    siteId: string,
    kpiName: string
  ): Observable<any> {
    return this.dataService.getData(
      this.getLoadVerticesOfSiteBasedOnUtilityUrl + '/' + siteId + '/' + kpiName
    );
  }

  public saveNodeDetailsForLoad(model: any): Observable<any> {
    return this.dataService.postData(this.saveNodeDetailsForLoadUrl, model);
  }
  public saveNodeDetails(model: any): Observable<any> {
    return this.dataService.postData(this.saveNodeDetailsUrl, model);
  }
  public addNodeForLoad(model: any): Observable<any> {
    return this.dataService.postData(this.addNodeForLoadUrl, model);
  }
  public getLoadsbasedOnTypeAndSubType(model: any): Observable<any> {
    return this.dataService.postData(
      this.getLoadsBasedOnTypeAndSubTypeUrl,
      model
    );
  }
  public getSensorDetailsBasedOnLoadId(model: any): Observable<any> {
    return this.dataService.postData(
      this.getSensorDetailsBasedOnLoadIdUrl,
      model
    );
  }
  // Add node
  public addNodesForLoads = (model: any): Observable<any> => {
    return this.dataService.postData(this.addNodesForLoadsUrl, model);
  };
  public getEnergySumForMeters = (
    siteid: string,
    fromdate: string,
    todate: string
  ): Observable<any> => {
    return this.dataService.getData(
      `${this.getEnergySumForMetersUrl}/${siteid}/${fromdate}/${todate}`
    );
  };
  // difference saveNodeDetailsForLoad, check later
  public saveNodeDetailForLoad = (model: any): Observable<any> => {
    return this.dataService.postData(this.saveNodeDetailsForLoadUrl, model);
  };
  public getLastRealtimeDataForLoad = (model: any): Observable<any> => {
    return this.dataService.postData(this.getLastRealtimeDataForLoadUrl, model);
  };
  //FAULT STATUS
  public getInvertersFaultStatus(model: any): Observable<any> {
    return this.dataService.postData(this.getInvertersFaultStatusUrl, model);
  }
}
